import React from 'react';
import { Time } from './Time';
import { formatAsLocalDateTime } from './util';

interface LocalDateTimeProps {
  /**
   * The date to be displayed. Can be a valid date string parseable by Date.parse() or a Unix timestamp in milliseconds.
   */
  date: string | number;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * LocalDateTime component displays a date and time in the "Jan 15, 2025 2:30 PM" format.
 * Mimics the formatAsLocalDateTime utility function.
 */
export const LocalDateTime: React.FC<LocalDateTimeProps> = ({ date, className }) => {
  const timestamp = typeof date === 'string' ? Date.parse(date) : date;

  const formattedDateTime = formatAsLocalDateTime(timestamp);

  return (
    <Time date={formattedDateTime} className={className}>
      {formattedDateTime}
    </Time>
  );
};
